import { defineStore } from "pinia";
import { http } from "@/extensions/http";
import API_ENDPOINTS from "@/config/API_ENDPOINTS.ts";
import i18n from "@/i18n";

export const usePageStore = defineStore("page", {
  state: () => ({
    memory: {
      index: {
        en: {},
        fr: {},
      } as Record<locale, Record<template, Page | undefined>>,
      show: {
        en: {},
        fr: {},
      } as Record<locale, Record<template, Page | undefined>>,
    },
  }),
  actions: {
    async all(): Promise<Record<template, Page>> {
      const locale: locale = i18n.global.locale.value;

      if (Object.keys(this.memory.index[locale]!).length > 0) {
        return this.memory.index[locale] as Record<template, Page>;
      }

      const { data } = await http.get<Record<template, Page>>(API_ENDPOINTS.PAGE.INDEX);

      this.memory.index[locale] = data;

      return data;
    },
    async get(pageTemplate: template) {
      const locale: locale = i18n.global.locale.value;

      if (this.memory.show[locale][pageTemplate] !== undefined) {
        return this.memory.show[locale][pageTemplate];
      }

      const { data } = await http.get<Page>(API_ENDPOINTS.PAGE.SHOW.replace(":page", pageTemplate));

      this.memory.show[locale][pageTemplate] = data;

      return data;
    },
  },
});
